import { render, staticRenderFns } from "./KockiceRedniBroj.vue?vue&type=template&id=060fe808&"
import script from "./KockiceRedniBroj.vue?vue&type=script&lang=js&"
export * from "./KockiceRedniBroj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports